import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { useTableContext } from "./table.context"
import TableCount from "./TableCount"
import TableToolbarFilterPanel from "./TableToolbarFilterPanel"
import TableToolbarColumnsPanel from "./TableToolbarColumnsPanel"
import TableAdvancedFilterPanel from "./TableAdvancedFilterPanel"

export type TableToolbarProps = ComponentProps<"div">

/**
 * Toolbar container. Renders inline panel below when a panel (filter/columns) is active.
 * The right edge always carries the "Showing X of Y" count, so filtered
 * tables show what they display without spending a line on it.
 */
function TableToolbar(props: TableToolbarProps) {
  const { className, children, ...divProps } = props
  const { activePanel, setActivePanel } = useTableContext()

  return (
    <>
      <div className={cn("ui-table-toolbar", className)} {...divProps}>
        {children}
        <TableCount className="ml-auto whitespace-nowrap pl-3 text-xs text-muted-foreground" />
      </div>

      {activePanel === "filter" && (
        <TableToolbarFilterPanel onClose={() => setActivePanel(null)} />
      )}

      {activePanel === "advancedFilter" && (
        <TableAdvancedFilterPanel onClose={() => setActivePanel(null)} />
      )}

      {activePanel === "columns" && (
        <TableToolbarColumnsPanel onClose={() => setActivePanel(null)} />
      )}
    </>
  )
}

export default TableToolbar
